import React from "react";
import {Snackbar, SnackbarCloseReason} from "@mui/material";
import {useTheme} from "../../../contexts/theme";

interface ErrorSnackBarProps {
    autoHideDuration: number;
    open: boolean;
    setClose: () => void;
    errorMessage: string;
}

const ErrorSnackBar: React.FC<ErrorSnackBarProps> = ({open, autoHideDuration, errorMessage, setClose}) => {

    const theme = useTheme();

    const handleClose = (
        event: React.SyntheticEvent | Event,
        reason?: SnackbarCloseReason,
    ) => {
        if (reason === 'clickaway') {
            return;
        }
        setClose();
    };

    return (
        <Snackbar

            anchorOrigin={theme.snackbarPosition}
            open={open}
            autoHideDuration={autoHideDuration}
            message={errorMessage}
            onClose={handleClose}
        />
    );
};

export default ErrorSnackBar;